import React from 'react';
import { Customers, EntityType } from '../../../entity.types';
import { cleanObject, cleanResults } from '../chartTypologies.utils';
import { CustomersTypologiesPresentation, CustomersTypologiesChart } from '..';

type Props = {
  customers: Customers;
  decisionCount: number;
  entityType: EntityType;
  entityId: string;
  entityName: string;
};

type State = {
  typologiesData: Array<number>;
  typologiesLabels: Array<string>;
};

export class CustomersTypologies extends React.Component<Props, State> {
  state: State = {
    typologiesData: [],
    typologiesLabels: [],
  };

  componentDidMount() {
    const { typologies } = cleanResults(this.props.customers);
    let typologiesData = null;
    let typologiesLabels = null;
    if (typologies != null) {
      const cleanTypologies = cleanObject(typologies);
      typologiesData = cleanTypologies.map(d => Math.round(d[1]));
      typologiesLabels = cleanTypologies.map(c => c[0]);
      this.setState({ typologiesData, typologiesLabels });
    }
  }

  render() {
    const { decisionCount, entityType, entityName, entityId } = this.props;
    const { typologiesData, typologiesLabels } = this.state;
    const entityInfos = {
      decisionCount,
      entityType,
      entityName,
      entityId,
    };
    return typologiesLabels.length > 0 && typologiesData.length > 0 ? (
      <CustomersTypologiesPresentation {...entityInfos}>
        <CustomersTypologiesChart
          typologiesLabels={typologiesLabels}
          typologiesData={typologiesData}
        />
      </CustomersTypologiesPresentation>
    ) : null;
  }
}
